// extracted by mini-css-extract-plugin
module.exports = {"languageSwitcher__button":"LanguageSwitcher_languageSwitcher__button___EH9y"};